var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('HrDashboardData'),_c('div',{staticClass:"stateChart"},[_c('HrDashboardStats',{staticStyle:{"width":"33%","padding-right":"25px"}}),_c('div',{staticStyle:{"width":"100%"}},[_c('HrDashboardTable',{staticStyle:{"margin-top":"20px"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }